import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function CustomAgentsAutomation() {
  return <DetailPage data={detailPages["custom-agents-automation"]} />;
}
